"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = props.children,
      name = props.name,
      onClick = props.onClick,
      style = props.style;
  var dataMap = {},
      key = '';

  for (key in props) {
    if (key && typeof key === 'string' && key.indexOf('data-') > -1) {
      dataMap[key] = props[key];
    }
  }

  return _react["default"].createElement("a", _extends({}, dataMap, {
    style: style,
    href: "javascript:;",
    onClick: onClick,
    "data-name": name
  }), children);
};

exports["default"] = _default;